var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('section-header'),_vm._v(" "),_c('div',{staticStyle:{"min-height":"100vh"}},[_c('router-view')],1),_vm._v(" "),_c('section-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }